import axios from "axios";

const base = `${process.env.REACT_APP_BACKEND_URL}/warranty`;
const token = () => localStorage.getItem("token");
const headers = () => ({ headers: { Authorization: "Bearer " + token() } });

export const getMeta = () => axios.get(`${base}/meta`, headers());
export const getOverview = project =>
  axios.get(`${base}/overview${project ? `?project=${project}` : ""}`, headers());
export const syncNow = () => axios.post(`${base}/sync`, {}, headers());

// Abnahmeprotokolle
export const listAcceptances = filters =>
  axios.post(`${base}/acceptances/list`, filters, headers());
export const createAcceptance = body => axios.post(`${base}/acceptances`, body, headers());
export const getAcceptance = id => axios.get(`${base}/acceptances/${id}`, headers());
export const updateAcceptance = (id, body) =>
  axios.put(`${base}/acceptances/${id}`, body, headers());
export const deleteAcceptance = id => axios.delete(`${base}/acceptances/${id}`, headers());
export const updateDefect = (id, defectId, body) =>
  axios.patch(`${base}/acceptances/${id}/defects/${defectId}`, body, headers());
export const signAcceptance = (id, body) =>
  axios.post(`${base}/acceptances/${id}/sign`, body, headers());
export const recordAcceptance = (id, body) =>
  axios.post(`${base}/acceptances/${id}/record`, body, headers());
export const refuseAcceptance = (id, body) =>
  axios.post(`${base}/acceptances/${id}/refuse`, body, headers());
export const requestAcceptance = (id, body) =>
  axios.post(`${base}/acceptances/${id}/request`, body, headers());
export const reopenAcceptance = (id, body) =>
  axios.post(`${base}/acceptances/${id}/reopen`, body, headers());
export const createSignLink = (id, body) =>
  axios.post(`${base}/acceptances/${id}/sign-link`, body, headers());
export const revokeSignLink = id => axios.delete(`${base}/acceptances/${id}/sign-link`, headers());
export const emailAcceptance = (id, body) =>
  axios.post(`${base}/acceptances/${id}/email`, body, headers());
export const deleteDefectPhoto = (id, defectId, photoId) =>
  axios.delete(`${base}/acceptances/${id}/defects/${defectId}/photos/${photoId}`, headers());

const photoForm = (blob, caption) => {
  const body = new FormData();
  body.append("photo", blob, blob.type === "image/png" ? "photo.png" : "photo.jpg");
  if (caption) body.append("caption", caption);
  return body;
};
export const uploadDefectPhoto = (id, defectId, blob, caption) =>
  axios.post(
    `${base}/acceptances/${id}/defects/${defectId}/photos`,
    photoForm(blob, caption),
    headers()
  );

// Gewährleistungen
export const listWarranties = filters => axios.post(`${base}/warranties/list`, filters, headers());
export const createWarranty = body => axios.post(`${base}/warranties`, body, headers());
export const getWarranty = id => axios.get(`${base}/warranties/${id}`, headers());
export const updateWarranty = (id, body) => axios.put(`${base}/warranties/${id}`, body, headers());
export const deleteWarranty = id => axios.delete(`${base}/warranties/${id}`, headers());
export const addClaim = (id, body) =>
  axios.post(`${base}/warranties/${id}/claims`, body, headers());
export const updateClaim = (id, claimId, body) =>
  axios.put(`${base}/warranties/${id}/claims/${claimId}`, body, headers());
export const deleteClaim = (id, claimId) =>
  axios.delete(`${base}/warranties/${id}/claims/${claimId}`, headers());
export const uploadClaimPhoto = (id, claimId, blob, caption) =>
  axios.post(
    `${base}/warranties/${id}/claims/${claimId}/photos`,
    photoForm(blob, caption),
    headers()
  );
export const recordInspection = (id, body) =>
  axios.post(`${base}/warranties/${id}/inspections`, body, headers());

// Bürgschaften
export const listGuarantees = filters => axios.post(`${base}/guarantees/list`, filters, headers());
export const createGuarantee = body => axios.post(`${base}/guarantees`, body, headers());
export const getGuarantee = id => axios.get(`${base}/guarantees/${id}`, headers());
export const updateGuarantee = (id, body) => axios.put(`${base}/guarantees/${id}`, body, headers());
export const deleteGuarantee = id => axios.delete(`${base}/guarantees/${id}`, headers());
export const setGuaranteeStatus = (id, body) =>
  axios.post(`${base}/guarantees/${id}/status`, body, headers());
export const createReturnLetter = (id, body) =>
  axios.post(`${base}/guarantees/${id}/return-letter`, body, headers());
export const emailReturnLetter = (id, body) =>
  axios.post(`${base}/guarantees/${id}/return-letter/email`, body, headers());
export const retentionCandidates = project =>
  axios.get(
    `${base}/guarantees/retention-candidates${project ? `?project=${project}` : ""}`,
    headers()
  );
export const replaceRetention = (id, invoiceIds) =>
  axios.post(`${base}/guarantees/${id}/replace-retention`, { invoiceIds }, headers());

// Links that open in a new tab or an <img> cannot send a header: the token goes in the query.
const withToken = url =>
  `${url}${url.includes("?") ? "&" : "?"}token=${encodeURIComponent(token() || "")}`;
export const acceptancePdfUrl = (id, lng) =>
  withToken(`${base}/acceptances/${id}/pdf?lng=${encodeURIComponent(lng || "de")}`);
export const requestLetterUrl = id => withToken(`${base}/acceptances/${id}/request-letter`);
export const defectPhotoUrl = (id, photoId) =>
  withToken(`${base}/acceptances/${id}/photos/${photoId}`);
export const claimPhotoUrl = (id, photoId) =>
  withToken(`${base}/warranties/${id}/photos/${photoId}`);
export const returnLetterUrl = id => withToken(`${base}/guarantees/${id}/return-letter`);

// The customer's page (no login; the tenant comes from ?domain=)
const publicBase = `${process.env.REACT_APP_BACKEND_URL}/public-acceptances`;
const domainQuery = domain => `?domain=${encodeURIComponent(domain || "")}`;
export const getPublicAcceptance = (token, domain) =>
  axios.get(`${publicBase}/${token}${domainQuery(domain)}`);
export const signPublicAcceptance = (token, domain, body) =>
  axios.post(`${publicBase}/${token}/sign${domainQuery(domain)}`, body);
export const refusePublicAcceptance = (token, domain, body) =>
  axios.post(`${publicBase}/${token}/refuse${domainQuery(domain)}`, body);
export const publicPdfUrl = (token, domain) => `${publicBase}/${token}/pdf${domainQuery(domain)}`;
export const publicPhotoUrl = (token, domain, photoId) =>
  `${publicBase}/${token}/photos/${photoId}${domainQuery(domain)}`;
